import { render, staticRenderFns } from "./intodctionInstitution.vue?vue&type=template&id=cc836c32&scoped=true&"
import script from "./intodctionInstitution.vue?vue&type=script&lang=js&"
export * from "./intodctionInstitution.vue?vue&type=script&lang=js&"
import style0 from "./intodctionInstitution.vue?vue&type=style&index=0&id=cc836c32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc836c32",
  null
  
)

export default component.exports